/* eslint-disable no-nested-ternary */

import { useDispatch, useSelector } from 'react-redux'

import { plannerProgramsThunks } from '@ucheba/store/planner/programs'

import { plannerPlanThunks, plannerPlanSelectors } from '@ucheba/store/planner/plan'

import {
  EAnalyticEvents,
  EAnalyticEventTargets,
  EAnalyticSections,
} from '@ucheba/utils/helpers/analytics/events/types'

import { analyticEvent } from '@ucheba/utils/helpers/analytics/events'

import { TUseProgramItem } from '../../types'

export const useProgramItem: TUseProgramItem = (id, probability) => {
  const probabilityForProgram =
    probability > 90 ? 'high' : probability > 50 ? 'medium' : 'low'

  const dispatch = useDispatch()

  const entityProgramIds = useSelector(plannerPlanSelectors.entityProgramIds)

  const isProgramInPlan = entityProgramIds.includes(id)

  const handleAddProgram = async (): Promise<void> => {
    await dispatch(
      plannerProgramsThunks.postPrograms({
        data: {
          entityIds: [id],
        },
      })
    )

    await dispatch(plannerPlanThunks.getProgramIds({}))

    analyticEvent({
      targets: [EAnalyticEventTargets.ym, EAnalyticEventTargets.ur],
      eventName: EAnalyticEvents.plannerProgramAdded,
      section: EAnalyticSections.popupAssessmentOfChances,
    })
  }

  const handleDeleteProgram = async (): Promise<void> => {
    await dispatch(
      plannerProgramsThunks.deletePrograms({
        data: {
          entityIds: [id],
        },
      })
    )

    await dispatch(plannerPlanThunks.getProgramIds({}))
  }

  return {
    isProgramInPlan,
    probabilityForProgram,
    handleAddProgram,
    handleDeleteProgram,
  }
}
